

/**
 *
 * @enum ActionType
 *
 * the kinds GUI actions that we can invoke from anywhere in the GUI
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */

export enum ActionType {

  /* panoramic view actions */

  PANO_ZOOM_IN             = 'pano_zoom_in',
  PANO_ZOOM_OUT            = 'pano_zoom_out',
  PANO_ZOOM_TO             = 'pano_zoom_to',
  PANO_LINK                = 'pano_link',
  PANO_LEFT                = 'pano_left',
  PANO_RIGHT               = 'pano_right',
  PANO_UP                  = 'pano_up',
  PANO_DOWN                = 'pano_down',
  PANO_RESET               = 'pano_reset',
  PANO_TOGGLE_MAP          = 'pano_toggle_map',
  PANO_TOGGLE_FILTER       = 'pano_toggle_filter',
  PANO_TOGGLE_CONTROLS     = 'pano_toggle_controls',
  PANO_TOGGLE_FULLSCREEN   = 'pano_toggle_fullscreen',
  PANO_NAVIGATE_BY_ID      = 'pano_navigate_by_id',

  BRIGHTNESS_RESET         = 'pano_brightness_reset',
  CONTRAST_RESET           = 'pano_contrast_reset',

  /* the overwatch screen */

  OVERWATCH_NAVIGATE_BY_ID = 'over_navigate_by_id',

  /* panorama selector */

  PANO_SELECTOR_HIDE       = 'pano_selector_hide',
  PANO_SELECTOR_SHOW       = 'pano_selector_show',
  PANO_SELECTOR_TOGGLE     = 'pano_selector_toggle',

  /* leaflet controls */

  LEAFLET_CONTROLS_SHOW    = 'leaflet_controls_show',
  LEAFLET_CONTROLS_HIDE    = 'leaflet_controls_hide',

  /* leaflet view */

  LEAFLET_RESET            = 'leaflet_reset',
  LEAFLET_ZOOM_IN          = 'leaflet_zoom_in',
  LEAFLET_ZOOM_OUT         = 'leaflet_zoom_out',

  /* panorama to panorama navigation */

  PANO_NAVIGATE_LEFT       = 'pano_navigate_left',
  PANO_NAVIGATE_RIGHT      = 'pano_navigate_right',
  PANO_NAVIGATE_NEXT       = 'pano_navigate_next',
  PANO_NAVIGATE_PREVIOUS   = 'pano_navigate_previous',
  PANO_NAVIGATE_BACK       = 'pano_navigate_back',
  PANO_UNLOCK_APPLICATION  = 'pano_unlock_application',

  /* generic */

  ACTION_CUSTOM            = 'custom',
  ACTION_NONE              = 'none'
}
